import { render, staticRenderFns } from "./BibliothequeMail.vue?vue&type=template&id=63d5eaf9&"
import script from "./BibliothequeMail.vue?vue&type=script&lang=js&"
export * from "./BibliothequeMail.vue?vue&type=script&lang=js&"
import style0 from "./BibliothequeMail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports